import { useLocation } from 'react-router-dom';
import { CATEGORIES, POPULAR_THEMES } from '../config';

export function useCategoryFromQuery() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const cat = params.get('category');
  return CATEGORIES.includes(cat) ? cat : 'All';
}

export function useThemeFromQuery() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const theme = params.get('theme');
  return POPULAR_THEMES.includes(theme) ? theme : null;
}


